import { useEffect, useState } from "react";
import axios from "axios";
import { Button, Col, FloatingLabel, Row, Form } from "react-bootstrap";
import PageLayout from "../../../layouts/PageLayout";
import { Link } from "react-router-dom";
import AssesmentDashboardRecord from "./AssesmentDashboardRecord";

const DashboardAssesment = () => {
  const [data, setData] = useState([]);
  const [filterValues, setFilterValues] = useState({
    from_date: "",
    to_date: "",
  });
  const [error, setError] = useState("");

  const AuthToken = localStorage.getItem("AuthUser");
  axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;

  // Initial load
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async (params = {}) => {
    try {
      const res = await axios.get(
        process.env.REACT_APP_API_URL + "/distribution-dashboard",
        { params }
      );
      setData(res.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedState = {
      ...filterValues,
      [name]: value,
    };
    setFilterValues(updatedState);

    const { from_date, to_date } = updatedState;
    if (
      (from_date && to_date && new Date(to_date) >= new Date(from_date)) ||
      (!from_date && !to_date)
    ) {
      setError("");
    }
  };

  const handleApplyFilter = async () => {
    const { from_date, to_date } = filterValues;

    if (!from_date && !to_date) {
      setError("Please enter From Date and To Date.");
      return;
    }
    if (from_date && !to_date) {
      setError("Please select a 'To Date' when 'From Date' is chosen.");
      return;
    }
    if (!from_date && to_date) {
      setError("Please select a 'From Date' when 'To Date' is chosen.");
      return;
    }
    if (from_date && to_date && new Date(to_date) < new Date(from_date)) {
      setError("'To Date' cannot be earlier than 'From Date'.");
      return;
    }

    setError("");
    fetchData(filterValues);
  };

  const handleClearFilter = async () => {
    setFilterValues({
      from_date: "",
      to_date: "",
    });
    setError("");
    fetchData();
  };

  return (
    <PageLayout>
      <Row>
        <Col xl={12}>
          <div className="mc-card">
            <div className="mc-breadcrumb">
              <h3 className="mc-breadcrumb-title">
                {"Family Assessment Dashboard"}
              </h3>
              <ul className="mc-breadcrumb-list">
                <li className="mc-breadcrumb-item">
                  <Link to="#" className="mc-breadcrumb-link" style={{ color: "#077834" }}>
                    {"home"}
                  </Link>
                </li>
                <li className="mc-breadcrumb-item">
                  <Link to="#" className="mc-breadcrumb-link" style={{ color: "#077834" }}>
                    {"Family Assessment"}
                  </Link>
                </li>
                <li className="mc-breadcrumb-item">{"Dashboard"}</li>
              </ul>
            </div>
          </div>
        </Col>
      </Row>

      {/* Date Filter */}
      <Row>
        <Col xl={12}>
          <div className="mc-card">
            <div className="mc-breadcrumb" style={{ marginBottom: "10px" }}>
              <h3 className="mc-breadcrumb-title">{"Filter by Date"}</h3>
            </div>
            <Row className="align-items-center g-3">
              <Col md="auto">
                <Form.Label className="mb-0">From:</Form.Label>
              </Col>
              <Col md={3}>
                <Form.Control
                  type="date"
                  name="from_date"
                  value={filterValues.from_date}
                  onChange={handleChange}
                />
              </Col>
              <Col md="auto">
                <Form.Label className="mb-0">To:</Form.Label>
              </Col>
              <Col md={3}>
                <Form.Control
                  type="date"
                  name="to_date"
                  value={filterValues.to_date}
                  onChange={handleChange}
                />
              </Col>
              <Col md="2">
                <Button
                  onClick={handleApplyFilter}
                  style={{
                    backgroundColor: "#077834",
                    fontWeight: "bold",
                    fontSize: "12px",
                  }}
                >
                  Apply Filter
                </Button>
              </Col>
              <Col md="2">
                <Button
                  onClick={handleClearFilter}
                  className="bg-secondary"
                  style={{ fontWeight: "bold", fontSize: "12px" }}
                >
                  Clear Filter
                </Button>
              </Col>
            </Row>
            {error && (
              <div className="text-danger mt-2" style={{ fontSize: "13px" }}>
                {error}
              </div>
            )}
          </div>
        </Col>
      </Row>

      {/* Records */}
      <Row>
        <AssesmentDashboardRecord data={data ? data : ""} />
      </Row>
    </PageLayout>
  );
};

export default DashboardAssesment;
